// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56110429","455":"c2f7bd09"}[chunkId] + ".chunk.js";
};